import React from 'react';

import Container from './Container';
import ThreeDigitExplanation from './ThreeDigitExplanation';
import FourDigitExplanation from './FourDigitExplanation';

export default ({ type }) => {
  let description = 'description';
  switch (type) {
    case 'amex':
      description = <FourDigitExplanation />;
      break;

    default:
      description = <ThreeDigitExplanation />;
      break;
  }
  return <Container>{description}</Container>;
};
